<template>
  <a-tabs v-model:activeKey="currentTab" destroyInactiveTabPane>
    <a-tab-pane v-if="!isInfinite" :key="1" tab="Recargas" :disabled="isLoading">
      <TransactionsTable :type="type" ref="transactionTableRef" @loading="isLoading = $event"/>
    </a-tab-pane>

    <a-tab-pane :key="2" tab="Consumos" :disabled="isLoading">
      <ExpensesTable v-if="type === ProductType.WhatsApp" ref="expensesTableRef" @loading="isLoading = $event"/>
      <WhatsappVoiceExpensesTable v-if="type === ProductType.WhatsAppVoice" ref="expensesTableRef" @loading="isLoading = $event"/>
      <VoiceExpensesTable v-if="type === ProductType.Voice" ref="expensesTableRef" @loading="isLoading = $event"/>
      <SmsExpensesTable v-if="type === ProductType.Sms" ref="expensesTableRef" @loading="isLoading = $event"/>
      <BotAITable v-if="type === ProductType.BotAI" ref="expensesTableRef" @loading="isLoading = $event"/>
      <TextToSpeechBillingTable v-if="type === ProductType.TextToSpeech" ref="expensesTableRef" @loading="isLoading = $event"/>
    </a-tab-pane>
  </a-tabs>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";

import { ProductType } from "@/@types/settings/billing";

import TransactionsTable from "@/app/settings/components/tables/TransactionsTable.vue";
import ExpensesTable from "@/app/settings/components/tables/ExpensesTable.vue";
import WhatsappVoiceExpensesTable from "@/app/settings/components/tables/WhatsappVoiceExpensesTable.vue";
import VoiceExpensesTable from "../tables/VoiceExpensesTable.vue";
import SmsExpensesTable from "@/app/settings/components/tables/SmsExpensesTable.vue";
import BotAITable from "@/app/settings/components/tables/BotAITable.vue";
import TextToSpeechBillingTable from "@/app/settings/components/tables/TextToSpeechBillingTable.vue";

const props = defineProps({ type: Number, isInfinite: Boolean });

const currentTab = ref(1);
const isLoading = ref(false);

watch(
  () => props.isInfinite,
  (isInfinite) => {
    if (isInfinite) currentTab.value = 2;
  }
);

const transactionTableRef = ref();
const expensesTableRef = ref();

const handleUpdate = async () => {
  await transactionTableRef.value?.fetchTransactionTableData();
  await expensesTableRef.value?.fetchExpensesTableData();
};

defineExpose({ handleUpdate });
</script>

<style lang="sass" scoped></style>
